module.exports = __webpack_public_path__ + "static/media/12.15c6ce7f.mp3";